import {
  Box,
  Center,
  Flex,
  GreyGrey20,
  GreyGrey70,
  GreyGrey80,
  Primary13Regular
} from '@sequencehq/core-components'
import { ReactNode } from 'react'

const MAX_WIDTH = '190px'

/**
 * The borderless pill the quote sidebar's rows are written in - the customer row sets the shape,
 * and this keeps anything sitting under it looking like part of the same list rather than a
 * control that has wandered in. The background only arrives on hover, so a row reads as text
 * until there is a reason to touch it.
 */
export const SidebarPill = ({
  icon,
  children,
  'data-testid': dataTestId
}: {
  icon: ReactNode
  children: ReactNode
  'data-testid'?: string
}) => (
  <Flex
    paddingX="6px"
    minHeight="24px"
    gap="6px"
    borderRadius="6px"
    _hover={{ background: GreyGrey20 }}
    justifyContent="center"
    alignItems="center"
    maxWidth={MAX_WIDTH}
    cursor="pointer"
    data-testid={dataTestId}
  >
    <Center flexShrink="0" color={GreyGrey70}>
      {icon}
    </Center>
    <Box
      {...Primary13Regular}
      color={GreyGrey80}
      textOverflow="ellipsis"
      whiteSpace="nowrap"
      overflow="hidden"
    >
      {children}
    </Box>
  </Flex>
)
